import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";

export const FeaturesMethodPage = (data) => {
    const features =
        [
            {
                title: "Paga en línea",
                img: "/png/pse.png",
                classTitle: "flex justify-between pb-6",
                //href: `${variablesGlobales.urlServiceBackend}/api/v1/wompi/checkout?value1=${btoa(data?.doc)}&value2=${btoa(data?.credit_id)}&value3=${btoa(data?.extendPlazo === true ? data?.totalSinCapital : data?.amount)}&value4=${btoa(data?.extendPlazo ?? false)}&value5=${btoa(data?.dateExtend)}`,
                classBox:
                    "col-span-8 border-2 border-purple xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white",
                details: [
                    {
                        description: "Paga en línea, rapido, seguro y fácil.",
                        icon: CheckCircleIcon,
                        id: 0,
                    },
                    {
                        description: "Verificación de tu pago inmediato.",
                        id: 1,
                        icon: CheckCircleIcon,
                    },
                    {
                        description: "Puedes renovar tu crédito al instante.",
                        id: 2,
                        icon: CheckCircleIcon,
                    },
                ],
                button: "Pagar ahora",
                wompiPay: true,
                isExtend: data?.extendPlazo,
            },
            {
                title: "Paga en efectivo",
                img: "/png/bancolombia.png",

                href:
                    data?.extendPlazo === true ? `/pago-efectivo-extend` : `/opciones-efectivo`,
                classBox:
                    "col-span-8 xl:col-span-4 grid content-between h-full rounded-3xl transition shadow-lg py-4 bg-white",
                details: [
                    {
                        description: "Paga en efectivo en un corresponsal Bancolombia.",
                        id: 0,
                        icon: ExclamationCircleIcon,
                    },
                    {
                        description: "Verificación de tu pago en hasta 1 día hábil.",
                        id: 1,
                        icon: ExclamationCircleIcon,
                    },
                    {
                        description: "Renueva tu crédito en hasta 2 días hábiles.",
                        id: 2,
                        icon: ExclamationCircleIcon,
                    },
                ],
                button: "Ver más",
                wompiPay: false,
                isExtend: data?.extendPlazo,
            },
        ]

    return features;
}  
